import { Component, Input, ChangeDetectionStrategy, OnChanges, SimpleChanges } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { LinkyModule } from "@teammood/shared/util/linky";
import { AnonymityPreviewComponent } from "../../../timeline-item-creation-dialog/anonymity-preview/anonymity-preview.component";
import { NotificationPreviewComponent } from "../../../timeline-item-creation-dialog/notification-preview/notification-preview.component";
import { PublicationPreviewComponent } from "../../../timeline-item-creation-dialog/publication-preview/publication-preview.component";
import { GifPreview, LinkPreview, Topic } from "../../timeline-item.types";
import { UserInfos } from "app/frontend/lib/shared/ui/username-icon/user-infos.type";
import { MoodsService } from "../../moods/moods.service";
import { GifPreviewComponent } from "../../../../shared/ui/gifpreview/gifpreview";


@Component({
    selector: 'topic-preview',
    templateUrl: 'topic-preview.component.html',
    styleUrls: ['./topic-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    TranslateModule,
    LinkyModule,
    AnonymityPreviewComponent,
    PublicationPreviewComponent,
    NotificationPreviewComponent,
    GifPreviewComponent
]
})
export class TopicPreviewComponent implements OnChanges {

    protected gifPreviews: GifPreview[] = [];

    @Input() topic: Topic;
    @Input() userInfos: UserInfos; 
    @Input() state: string; 
    @Input() notify: boolean;
    @Input() title: string;
  
    constructor(
        private moodsService: MoodsService
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.title?.currentValue) {
            this.get_link_previews();
        }
    }

    async get_link_previews () {
        if (this.topic &&  this.topic.title) {
            const previews : LinkPreview[] = (await this.moodsService.getCommentLinkPreviews(this.topic.title.body));
            this.gifPreviews = previews.filter(preview => preview.url.slice(-4) === '.gif').map(preview => new GifPreview(preview));
        } else {
             this.gifPreviews = [];
        }
    };
}